export default __webpack_public_path__ + "static/media/upload.3568396d.svg";